/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TestSttCommand } from '../../models/test-stt-command';
import { TestSttResult } from '../../models/test-stt-result';

export interface ApiModelsSttTestPost$Params {
      body?: TestSttCommand
}

export function apiModelsSttTestPost(http: HttpClient, rootUrl: string, params?: ApiModelsSttTestPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TestSttResult>> {
  const rb = new RequestBuilder(rootUrl, apiModelsSttTestPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TestSttResult>;
    })
  );
}

apiModelsSttTestPost.PATH = '/api/Models/stt/test';
